import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InputAdornment } from '@mui/material';

import AutoSaveTextField from '../../AutoSaveTextField';

const UpdateAffectedPiecesInputComponent = ({ value, disabled, handleUpdate, onFormChange }) => {
    const { t } = useTranslation();

    const [isError, setIsError] = useState(false);

    const handleBlur = event => {
        const raw = event.target.value;

        if (raw === '') {
            setIsError(true);
            onFormChange?.({ quantityData: { defected: null, total: value?.total } });
            return;
        }

        setIsError(false);

        handleUpdate('basicInformation', {
            basicInformation: {
                quantityData: {
                    defected: +raw,
                    total: value?.total,
                },
            },
        });
    };

    return (
        <AutoSaveTextField
            required
            error={isError || value?.defected == null || value?.defected === ''}
            onlyPositiveDigits
            value={value?.defected}
            disabled={disabled}
            type="number"
            onBlur={handleBlur}
            onKeyPress={event => {
                event.key === 'Enter' && handleBlur(event);
            }}
            label={t('report.form.affectedPieces')}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <span>Stk</span>
                    </InputAdornment>
                ),
            }}
            fullWidth
        />
    );
};

const UpdateAffectedPiecesInput = memo(UpdateAffectedPiecesInputComponent);

export default UpdateAffectedPiecesInput;
